class ProductMatchQuiz extends HTMLElement {
    constructor() {
        super();
        // Set up references once DOM is parsed; connectedCallback works but setTimeout(0) is a quick polyfill for children parsing if we rely on it immediately.
        // Enterprise theme uses initLazyScript or just safe DOM parsing. We will use connectedCallback.
    }

    connectedCallback() {
        this.customerId = this.dataset.customerId;
        this.screens = Array.from(this.querySelectorAll('.quiz-screen'));
        this.progressBar = this.querySelector('.quiz-progress-bar');
        this.nameInput = this.querySelector('#quiz-first-name');
        
        if(!this.screens.length) return;

        this.currentStep = 0;
        this.storageKey = this.customerId ? `quiz_result_${this.customerId}` : 'quiz_result_guest';
        this.progressKey = this.customerId ? `quiz_progress_${this.customerId}` : 'quiz_progress_guest';
        this.savedData = JSON.parse(localStorage.getItem(this.storageKey));
        
        const rawProgress = localStorage.getItem(this.progressKey);
        if (rawProgress) {
            try {
                const p = JSON.parse(rawProgress);
                if (p && p.step > 0 && p.step <= this.screens.length - 1) {
                    if (this.nameInput && p.name) this.nameInput.value = p.name;
                    if (p.name) {
                        const userNameSpans = this.querySelectorAll('.quiz-user-name');
                        userNameSpans.forEach(s => s.textContent = p.name);
                    }
                    if (p.answers) {
                        this.screens.forEach(s => {
                            const bId = s.dataset.blockId;
                            if (bId && p.answers[bId]) {
                                const btns = Array.from(s.querySelectorAll('.quiz-answer-btn'));
                                p.answers[bId].forEach(tagStr => {
                                    const btn = btns.find(b => b.dataset.tags === tagStr);
                                    if(btn) {
                                        btn.classList.add('selected');
                                        btn.setAttribute('aria-pressed', 'true');
                                    }
                                });
                                this.validateNextButton(s);
                            }
                        });
                    }
                    this.addEventListener('click', this.handleClick.bind(this));
                    this.goToStep(p.step);
                    return;
                }
            } catch (e) {}
        }
        
        const resumeBtn = this.querySelector('.quiz-btn-resume');
        if (this.savedData && resumeBtn) {
            resumeBtn.style.display = 'inline-flex';
            resumeBtn.addEventListener('click', () => {
                this.nameInput.value = this.savedData.name || '';
                this.screens.forEach(s => {
                    const blockId = s.dataset.blockId;
                    if(blockId && this.savedData.answers && this.savedData.answers[blockId]) {
                        const btns = Array.from(s.querySelectorAll('.quiz-answer-btn'));
                        this.savedData.answers[blockId].forEach(tagStr => {
                            const btn = btns.find(b => b.dataset.tags === tagStr);
                            if(btn) {
                                btn.classList.add('selected');
                                btn.setAttribute('aria-pressed', 'true');
                            }
                        });
                        this.validateNextButton(s);
                    }
                });
                this.goToStep(this.screens.length - 1);
            });
        }

        this.addEventListener('click', this.handleClick.bind(this));
        
        const parentSection = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
        if(parentSection && this.currentStep === 0) {
            parentSection.classList.add('is-welcome-active');
        }
    }

    saveProgress() {
        if (this.currentStep === 0) return;
        
        let answersData = {};
        this.screens.forEach(screen => {
            const blockId = screen.dataset.blockId;
            if(!blockId) return;
            const selected = screen.querySelectorAll('.quiz-answer-btn.selected');
            answersData[blockId] = [];
            selected.forEach(btn => {
                answersData[blockId].push(btn.dataset.tags);
            });
        });

        const progressPayload = {
            step: this.currentStep,
            name: this.nameInput ? this.nameInput.value.trim() : '',
            answers: answersData
        };
        localStorage.setItem(this.progressKey, JSON.stringify(progressPayload));
    }

    goToStep(index) {
        this.screens[this.currentStep].classList.remove('active');
        this.currentStep = index;
        this.screens[this.currentStep].classList.add('active');
        this.screens[this.currentStep].setAttribute('tabindex', '-1');
        this.screens[this.currentStep].focus();
        
        const progress = (this.currentStep / (this.screens.length - 1)) * 100;
        if(this.progressBar) {
            this.progressBar.style.width = `${progress}%`;
            const progressText = this.progressBar.querySelector('.quiz-progress-text');
            if (progressText) {
                if (this.currentStep === 0) {
                    progressText.textContent = '';
                } else if (this.currentStep === this.screens.length - 1) {
                    progressText.textContent = 'Results';
                } else {
                    progressText.textContent = `${this.currentStep} of ${this.screens.length - 2}`;
                }
            }
        }

        const parentSection = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
        if (parentSection) {
            if (this.currentStep === 0) {
                parentSection.classList.add('is-welcome-active');
            } else {
                parentSection.classList.remove('is-welcome-active');
            }
        }

        const quizContainer = this.querySelector('.quiz-container');
        const readingContainer = this.querySelector('.reading-width--inline') || this.querySelector('.container');
        if (this.currentStep === this.screens.length - 1) {
            if (quizContainer) quizContainer.classList.add('is-expanded');
            if (readingContainer) readingContainer.classList.remove('reading-width--inline');
            this.generateResults();
        } else {
            if (quizContainer) quizContainer.classList.remove('is-expanded');
            if (readingContainer) readingContainer.classList.add('reading-width--inline');
            this.saveProgress();
        }
    }

    validateNextButton(screen) {
        const nextBtn = screen.querySelector('.quiz-btn-next');
        const hasSelected = screen.querySelectorAll('.quiz-answer-btn.selected').length > 0;
        if(nextBtn) nextBtn.disabled = !hasSelected;
    }

    handleClick(e) {
        if (e.target.closest('.quiz-btn-start')) {
            if (!this.nameInput.value.trim()) {
                alert('Please enter your first name');
                return;
            }
            const userNameSpans = this.querySelectorAll('.quiz-user-name');
            userNameSpans.forEach(s => s.textContent = this.nameInput.value.trim());
            this.goToStep(this.currentStep + 1);
        }

        if (e.target.closest('.quiz-btn-prev')) {
            if (this.currentStep > 0) this.goToStep(this.currentStep - 1);
        }

        if (e.target.closest('.quiz-btn-next')) {
            this.goToStep(this.currentStep + 1);
        }

        const answerBtn = e.target.closest('.quiz-answer-btn');
        if (answerBtn) {
            const screen = answerBtn.closest('.quiz-screen-question');
            const isMulti = screen.querySelector('.quiz-answers').dataset.multi === 'true';
            
            if (!isMulti) {
                screen.querySelectorAll('.quiz-answer-btn').forEach(b => {
                    b.classList.remove('selected');
                    b.setAttribute('aria-pressed', 'false');
                });
                answerBtn.classList.add('selected');
                answerBtn.setAttribute('aria-pressed', 'true');
            } else {
                const isSelected = answerBtn.classList.toggle('selected');
                answerBtn.setAttribute('aria-pressed', isSelected.toString());
            }
            this.validateNextButton(screen);
            this.saveProgress();
        }

        if (e.target.closest('.quiz-btn-restart')) {
            localStorage.removeItem(this.progressKey);
            this.screens.forEach(s => {
                s.querySelectorAll('.quiz-answer-btn').forEach(b => {
                    b.classList.remove('selected');
                    b.setAttribute('aria-pressed', 'false');
                });
                this.validateNextButton(s);
            });
            this.goToStep(0);
        }
        
        if (e.target.closest('.quiz-btn-add-to-cart')) {
            const btn = e.target.closest('.quiz-btn-add-to-cart');
            const variantId = Number(btn.dataset.variantId);
            const qtyInput = btn.closest('.quiz-product-info').querySelector('.quiz-qty-input');
            const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
            this.addToCart([{ id: variantId, quantity: qty }], btn);
        }

        if (e.target.closest('.quiz-btn-bundle')) {
            const btn = e.target.closest('.quiz-btn-bundle');
            const productCards = this.querySelectorAll('.quiz-product-info');
            let items = [];
            productCards.forEach(card => {
                const addBtn = card.querySelector('.quiz-btn-add-to-cart');
                const qtyInput = card.querySelector('.quiz-qty-input');
                if (addBtn && addBtn.dataset.variantId) {
                    const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
                    if (qty > 0) items.push({ id: Number(addBtn.dataset.variantId), quantity: qty });
                }
            });
            if(items.length) this.addToCart(items, btn);
        }

        if (e.target.closest('.quiz-qty-plus')) {
            const input = e.target.closest('.quiz-qty-pill').querySelector('.quiz-qty-input');
            if(input) input.value = parseInt(input.value) + 1;
        }

        if (e.target.closest('.quiz-qty-minus')) {
            const input = e.target.closest('.quiz-qty-pill').querySelector('.quiz-qty-input');
            if(input && parseInt(input.value) > 1) {
                input.value = parseInt(input.value) - 1;
            }
        }
    }

    async generateResults() {
        let handleScores = {};
        let answersData = {};
        
        this.screens.forEach(screen => {
            const blockId = screen.dataset.blockId;
            if(!blockId) return;
            const selected = screen.querySelectorAll('.quiz-answer-btn.selected');
            answersData[blockId] = [];
            selected.forEach(btn => {
                answersData[blockId].push(btn.dataset.tags);
                const handles = btn.dataset.tags.split(',').map(s=>s.trim()).filter(s=>s);
                handles.forEach(h => {
                    handleScores[h] = (handleScores[h] || 0) + 1;
                });
            });
        });

        const resultPayload = {
            name: this.nameInput.value.trim(),
            date: new Date().toISOString(),
            answers: answersData,
            scores: handleScores
        };
        localStorage.setItem(this.storageKey, JSON.stringify(resultPayload));

        const historyBanner = this.querySelector('.quiz-history-banner');
        if(this.customerId && this.savedData && this.savedData.date) {
            historyBanner.style.display = 'block';
            historyBanner.textContent = `Welcome back! Your last quiz was taken on ${new Date(this.savedData.date).toLocaleDateString()}.`;
        }

        const sortedHandles = Object.keys(handleScores).sort((a,b) => handleScores[b] - handleScores[a]);
        
        const resultsScreen = this.querySelector('.quiz-screen-results');
        const limitStr = resultsScreen.dataset.limit;
        const limit = parseInt(limitStr) || 3;
        const topHandles = sortedHandles.slice(0, limit);

        const bundleWrapper = this.querySelector('.quiz-group-bundles');
        const manualWrapper = this.querySelector('.quiz-group-manual');
        const bundleGrid = this.querySelector('.bundle-grid');
        const manualGrid = this.querySelector('.manual-grid');
        const loadingBanner = this.querySelector('.quiz-loading-banner');

        if(bundleGrid) bundleGrid.innerHTML = '';
        if(manualGrid) manualGrid.innerHTML = '';
        if(bundleWrapper) bundleWrapper.style.display = 'none';
        if(manualWrapper) manualWrapper.style.display = 'none';
        
        if (topHandles.length === 0) {
            if(loadingBanner) loadingBanner.innerHTML = '<p class="rte">No matching products found. Try changing your answers!</p>';
            return;
        }

        if(loadingBanner) loadingBanner.innerHTML = '<div class="quiz-loading text-body">Fetching recommendations...</div>';
        
        const products = [];
        for (const handle of topHandles) {
            try {
                const res = await fetch(`/products/${handle}.js`);
                if(res.ok) {
                    const data = await res.json();
                    products.push(data);
                }
            } catch(e) {
                console.error('Error fetching product', handle, e);
            }
        }

        if(loadingBanner) loadingBanner.style.display = 'none';

        if(products.length === 0) {
            if(loadingBanner) {
                loadingBanner.style.display = 'block';
                loadingBanner.innerHTML = '<p class="rte">Oops, couldn\'t find products for those answers.</p>';
            }
            return;
        }

        const template = document.getElementById('quiz-product-card-template');
        let bundleCount = 0;
        let manualCount = 0;

        products.forEach(prod => {
            const availableVariant = prod.variants.find(v => v.available) || prod.variants[0];
            const clone = template.content.cloneNode(true);
            clone.querySelector('.quiz-product-title').textContent = prod.title;
            const formatter = new Intl.NumberFormat(window.Shopify?.locale || 'en-US', {
                style: 'currency',
                currency: window.Shopify?.currency?.active || 'USD'
            });
            clone.querySelector('.quiz-product-price').textContent = formatter.format(availableVariant.price / 100);
            if(prod.featured_image) {
                clone.querySelector('img').src = prod.featured_image;
                clone.querySelector('img').alt = prod.title;
            }
            clone.querySelector('.quiz-btn-add-to-cart').dataset.variantId = availableVariant.id;

            const titleMatch = prod.title && prod.title.toLowerCase().includes('bundle');
            const typeMatch = prod.type && prod.type.toLowerCase().includes('bundle');

            if (titleMatch || typeMatch) {
                if(bundleGrid) bundleGrid.appendChild(clone);
                bundleCount++;
            } else {
                if(manualGrid) manualGrid.appendChild(clone);
                manualCount++;
            }
        });

        if (bundleCount > 0 && bundleWrapper) bundleWrapper.style.display = 'block';
        if (manualCount > 0 && manualWrapper) manualWrapper.style.display = 'block';

        const bundleBtn = this.querySelector('.quiz-bundle-action');
        if(bundleBtn && products.length > 1) {
            bundleBtn.style.display = 'block';
        }
    }

    async addToCart(items, btnElement) {
        const originalText = btnElement.textContent;
        const originalClasses = btnElement.className;
        btnElement.textContent = 'Adding...';
        btnElement.disabled = true;
        btnElement.classList.add('is-loading');

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            });
            
            if (response.ok) {
                btnElement.textContent = 'Added!';
                btnElement.classList.remove('is-loading');
                if (btnElement.classList.contains('quiz-btn-bundle')) {
                    window.location.href = '/cart';
                    return;
                }
                if (window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer') {
                    // Try to open drawer by dispatching event or relying on native scripts
                    document.dispatchEvent(new CustomEvent('on:cart:add'));
                }
                setTimeout(() => {
                    btnElement.textContent = originalText;
                    btnElement.disabled = false;
                }, 2000);
            } else {
                throw new Error('Failed to add');
            }
        } catch(e) {
            btnElement.classList.remove('is-loading');
            btnElement.textContent = 'Error';
            setTimeout(() => {
                btnElement.textContent = originalText;
                btnElement.disabled = false;
            }, 2000);
        }
    }
}

if (!customElements.get('product-match-quiz')) {
    customElements.define('product-match-quiz', ProductMatchQuiz);
}
